const userIdMap = {
  wqj: '311602265921744161',  //吴绮君
  lqy: '01561359205126075190' //李倩影
}

export default userIdMap
